<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm()"
  (cancel)="cancel()"
  data-test="create-production-purpose-category-dialog"
>
  <div class="flex--container">
    @if (displayNameField) {
      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
          <mat-label>{{ 'productionPurposeCategory.name' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="name"
            data-test="create-production-purpose-category-name"
          />
          @if (formGroup.controls.name.hasError('required')) {
            <mat-error> {{ 'productionPurposeCategory.name' | translate }} is required </mat-error>
          }
          @if (formGroup.controls.name.hasError('maxlength')) {
            <mat-error>
              {{ 'productionPurposeCategory.name' | translate }} cannot be longer than 2 characters
            </mat-error>
          }
          @if (formGroup.controls.name.hasError('pattern')) {
            <mat-error>
              {{ 'productionPurposeCategory.name' | translate }} must only contain letters
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.description' | translate }}</mat-label>
        <input
          type="text"
          matInput
          formControlName="description"
          data-test="create-production-purpose-category-description"
        />
        @if (formGroup.controls.description.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.description' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.description.hasError('maxlength')) {
          <mat-error>
            {{ 'productionPurposeCategory.description' | translate }} cannot be longer than 50
            characters
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.n1' | translate }}</mat-label>
        <input
          matInput
          formControlName="n1"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-n1"
        />
        @if (formGroup.controls.n1.hasError('required')) {
          <mat-error> {{ 'productionPurposeCategory.n1' | translate }} is required </mat-error>
        }
        @if (formGroup.controls.n1.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.n1' | translate }} must only contain whole numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.n2' | translate }}</mat-label>
        <input
          matInput
          formControlName="n2"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-n2"
        />
        @if (formGroup.controls.n2.hasError('required')) {
          <mat-error> {{ 'productionPurposeCategory.n2' | translate }} is required </mat-error>
        }
        @if (formGroup.controls.n2.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.n2' | translate }} must only contain whole numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.n3' | translate }}</mat-label>
        <input
          matInput
          formControlName="n3"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-n3"
        />
        @if (formGroup.controls.n3.hasError('required')) {
          <mat-error> {{ 'productionPurposeCategory.n3' | translate }} is required </mat-error>
        }
        @if (formGroup.controls.n3.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.n3' | translate }} must only contain whole numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.baseYieldPotential' | translate }}</mat-label>
        <input
          matInput
          formControlName="baseYieldPotential"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-baseYieldPotential"
        />
        @if (formGroup.controls.baseYieldPotential.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.baseYieldPotential' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.baseYieldPotential.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.baseYieldPotential' | translate }} must only contain whole
            numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.nCorrection' | translate }}</mat-label>
        <input
          matInput
          formControlName="nCorrection"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-nCorrection"
        />
        @if (formGroup.controls.nCorrection.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.nCorrection' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.nCorrection.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.nCorrection' | translate }} must only contain whole
            numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.nO3NormTreshold' | translate }}</mat-label>
        <input
          matInput
          formControlName="nO3NormTreshold"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-nO3NormTreshold"
        />
        @if (formGroup.controls.nO3NormTreshold.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.nO3NormTreshold' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.nO3NormTreshold.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.nO3NormTreshold' | translate }} must only contain whole
            numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.trendlineTuningA' | translate }}</mat-label>
        <input
          matInput
          formControlName="trendlineTuningA"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-trendlineTuningA"
        />
        @if (formGroup.controls.trendlineTuningA.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningA' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.trendlineTuningA.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningA' | translate }} must only contain numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.trendlineTuningB' | translate }}</mat-label>
        <input
          matInput
          formControlName="trendlineTuningB"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-trendlineTuningB"
        />
        @if (formGroup.controls.trendlineTuningB.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningB' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.trendlineTuningB.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningB' | translate }} must only contain numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.trendlineTuningC' | translate }}</mat-label>
        <input
          matInput
          formControlName="trendlineTuningC"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-trendlineTuningC"
        />
        @if (formGroup.controls.trendlineTuningC.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningC' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.trendlineTuningC.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningC' | translate }} must only contain numbers
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'productionPurposeCategory.trendlineTuningD' | translate }}</mat-label>
        <input
          matInput
          formControlName="trendlineTuningD"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-production-purpose-category-property-trendlineTuningD"
        />
        @if (formGroup.controls.trendlineTuningD.hasError('required')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningD' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.trendlineTuningD.hasError('pattern')) {
          <mat-error>
            {{ 'productionPurposeCategory.trendlineTuningD' | translate }} must only contain numbers
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
